import {call, put, select, takeEvery} from 'redux-saga/effects';
import {logError} from '@yandex-int/pythia-libs/lib/rum';

import {setStatistics, fetchBrandliftStats} from 'client/common/store/actions/statistics';
import {getSlug} from 'client/common/store/selectors/survey';
import {getUplifts} from 'client/common/store/selectors/statistics';
import {ApiResponse} from 'client/common/store/saga/types';

import {MetricStatistics, Statistics} from 'client/common/types/brandlift/types';

import {getSurveyStatistics, getSurveyUplifts} from 'client/common/utils/api-client/constructor';
import {isErrorResponse} from 'client/common/utils/api-client/types';

// eslint-disable-next-line max-statements
export function* fetchStatistics(action: ReturnType<typeof fetchBrandliftStats>) {
    const slug: ReturnType<typeof getSlug> = yield select(getSlug);

    if (!slug) {
        return;
    }

    const uplifts: ReturnType<typeof getUplifts> = yield select(getUplifts);
    const isFilterActive = Boolean(action.payload?.filter);

    try {
        // @ts-ignore
        const res: ApiResponse<typeof getSurveyStatistics> = yield call(getSurveyStatistics, {
            slug,
            isBrandlift: true,
            filter: action.payload?.filter
        });

        let upliftResponse: ApiResponse<typeof getSurveyUplifts> | undefined;

        if (!uplifts) {
            upliftResponse = yield call(getSurveyUplifts, {slug});
        }

        if (res.data && !isErrorResponse(res.data)) {
            // eslint-disable-next-line max-depth
            if (
                upliftResponse?.status === 200 &&
                upliftResponse.data &&
                !upliftResponse.data.error
            ) {
                yield call(
                    // @ts-ignore
                    handleFetchStatisticsSuccess,
                    res.data,
                    isFilterActive,
                    upliftResponse.data
                );
            } else {
                // @ts-ignore
                yield call(handleFetchStatisticsSuccess, res.data, isFilterActive);
            }
        } else {
            yield call(handleFetchStatisticsFailure, res?.data?.reason);
        }
    } catch (e) {
        const res: ReturnType<typeof handleFetchStatisticsFailure> = yield call(
            handleFetchStatisticsFailure,
            e.message
        );

        return res;
    }
}

export function* handleFetchStatisticsSuccess(
    data: Statistics,
    isFilterActive: boolean,
    uplifts?: any
) {
    // Если среди приростов есть отрицательный, статистически значимый, кидаем об этом ошибку в сентри
    // Надеемся что кто нибудь увидит эту ощибку
    if (!data.metrics) {
        const result: ReturnType<typeof handleFetchStatisticsFailure> = yield call(
            handleFetchStatisticsFailure,
            'Statistics data is not valid'
        );

        return result;
    }

    const isExtraordinaryValue = Object.values(data.metrics).some(
        ({raise, significant}: MetricStatistics) => Number(raise) < 0 && significant === 1
    );

    if (isExtraordinaryValue) {
        yield call(logError, {message: 'Extraordinary KPI raise value', level: 'warn'});
    }

    if (uplifts) {
        data.uplifts = uplifts;
    }
    // с выбранным фильтром обновляем только данные по ответам
    data.isFilterActive = isFilterActive;

    yield put(setStatistics(data));
}

export function* handleFetchStatisticsFailure(message: string) {
    yield call(logError, {message});
}

export default function* router() {
    yield takeEvery(fetchBrandliftStats.type, fetchStatistics);
}
